<template>
  <div class="wrapper">
    <div class="page-header">
      <div class="page-ribbon">
        <div class="path">
          <img
            src="@/assets/admin-icon/home-active.svg"
          /><pathViewer></pathViewer>
        </div>
        <div class="ribbon-options"></div>
      </div>
    </div>
    <div class="page-body">
      <div class="search-section">
        <div class="search-inputs">
          <div class="search-widget">
            <div class="search-group">
              <img class="search" src="@/assets/icons/search.svg" />
              <input
                placeholder="Search"
                v-model="search_text"
                type="Type in to Search"
                @keypress.enter="submitSearch()"
              />
            </div>
          </div>
          <div class="search-category-widget">
            <miltSelect
              :content="search_categories"
              v-model="search_categories_input"
            ></miltSelect>
          </div>
          <div class="search-action">
            <c-button
              :loading="search_loading"
              class="search-btn"
              @click="submitSearch()"
              >Search</c-button
            >
          </div>
        </div>
        <div class="search-tags">
          <div
            class="tag"
            v-for="(item, index) in search_categories_input"
            :key="index"
          >
            <span class="label">{{ item | validate }}</span>
            <button class="remove-btn" @click="removeSearchInCategory(index)">
              <img src="@/assets/admin-icon/cross-icon.svg" />
            </button>
          </div>
        </div>
      </div>

      <!-- Search result -->
      <div class="search-result-widget" v-if="search_result">
        <div class="search-result-header">Consultants</div>
        <div
          class="search-item"
          v-for="(item, index) in search_site_result"
          :key="index + 'add'"
        >
          <img src="@/assets/avatar.png" />
          <div class="content">
            <label
              >{{ item.first_name | validate }}
              {{ item.last_name | validate }}</label
            >
            <div class="info-widget">
              <div class="info-item divider">{{ item.email | validate }}</div>
              <div class="info-item">Consultants</div>
            </div>
          </div>
        </div>
        <div class="search-result-header">Contacts</div>
        <div
          class="search-item"
          v-for="(item, index) in search_result.Contacts"
          :key="index + 'add'"
          @click="
            $router.push({
              name: 'accounts',
              params: { type: 'contacts', id: item.id },
            })
          "
        >
          <img src="@/assets/avatar.png" />
          <div class="content">
            <label
              >{{ item.first_name | validate }}
              {{ item.last_name | validate }}</label
            >
            <div class="info-widget">
              <div class="info-item divider">{{ item.email | validate }}</div>
              <div class="info-item">{{ item.phone_alt | validate }}</div>
            </div>
          </div>
        </div>
        <div class="search-result-header">Accounts</div>
        <div
          class="search-item"
          v-for="(item, index) in search_result.Accounts"
          :key="index + 'c'"
          @click="
            $router.push({
              name: 'account-view',
              params: { type: 'overview', id: item.id },
            })
          "
        >
          <img src="@/assets/avatar.png" />
          <div class="content">
            <label>{{ item.name | validate }}</label>
            <div class="info-widget">
              <div class="info-item divider">{{ item.phone | validate }}</div>
              <div class="info-item">{{ item.location | validate }}</div>
            </div>
          </div>
        </div>
        <div class="search-result-header">Tasks, Leads and Candidates</div>
        <div
          class="search-item"
          v-for="(item, index) in search_result.Candidates"
          :key="index + 'a'"
          @click="
            $router.push({
              name: 'candidates',
              params: { id: item.id },
            })
          "
        >
          <img src="@/assets/avatar.png" />
          <div class="content">
            <label>{{ item.name | validate }}</label>
            <div class="info-widget">
              <div class="info-item divider">{{ item.phone | validate }}</div>
              <div class="info-item">Candidate</div>
            </div>
          </div>
        </div>
        <div
          class="search-item"
          v-for="(item, index) in search_result.Leads"
          :key="index + 'b'"
          @click="
            $router.push({
              name: 'leads',
              params: { id: item.id },
            })
          "
        >
          <img src="@/assets/avatar.png" />
          <div class="content">
            <label>{{ item.name | validate }}</label>
            <div class="info-widget">
              <div class="info-item divider">${{ item.value | validate }}</div>
              <div class="info-item">Leads</div>
            </div>
          </div>
        </div>
        <div
          class="search-item"
          v-for="(item, index) in search_result.Tasks"
          :key="index + 'd'"
          @click="
            $router.push({
              name: 'task',
              params: { id: item.id },
            })
          "
        >
          <img src="@/assets/avatar.png" />
          <div class="content">
            <label>{{ item.name | validate }}</label>
            <div class="info-widget">
              <div class="info-item">Task</div>
            </div>
          </div>
        </div>
        <div class="result-counter-widget" v-if="false">
          <div class="result-number">1.535 results</div>
          <div class="show-more-result">
            Show me more results
            <button>
              <img src="@/assets/admin-icon/arrow-right-long.svg" />
            </button>
          </div>
        </div>
      </div>
      <!-- No search result -->
      <div v-else class="waiting-search">
        <h4>Nothing to search, Type something to start searching...</h4>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Search",
  components: {},
  data() {
    return {
      search_categories: [
        "Tasks",
        "Contacts",
        "Leads",
        "Candidates",
        "Accounts",
        "Organisation",
        // "Resumes",
        "Profile",
      ],
      search_text: "",
      search_categories_input: [
        "Tasks",
        "Contacts",
        "Leads",
        "Candidates",
        "Accounts",
        "Organisation",
        // "Resumes",
        "Profile",
      ],
      search_result: null,
      search_site_result: null,
      search_loading: false,
      team_ids: [],
      department_data: [],
    };
  },
  mounted() {
    let vm = this;
    let path = [
      {
        label: "Search",
        active: true,
      },
    ];
    vm.$store.commit("SET_PATH", path);
    vm.getDepartmentData();
  },
  watch: {},
  methods: {
    getDepartmentData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("GET_ALL_USER_INFO")
        .then((response) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.department_data = response.data;
          vm.department_data.forEach((item) => {
            item.teams.forEach((team) => {
              vm.team_ids.push(team.id);
            });
          });
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    removeSearchInCategory(index) {
      let vm = this;
      vm.search_categories_input.splice(index, 1);
      vm.submitSearch();
    },
    submitSearch() {
      let vm = this;
      vm.search_loading = true;
      vm.$store
        .dispatch("SEARCH_ALL_CRM", {
          query: vm.search_text,
          categories: vm.search_categories_input,
          team_ids: vm.team_ids,
        })
        .then((response) => {
          vm.search_loading = false;
          vm.search_result = response.data;
          console.log(vm.search_result);
        })
        .catch((error) => {
          vm.search_loading = false;
          console.error({ error });
        });
      vm.$store
        .dispatch("SEARCH_ALL_SITE", {
          query: vm.search_text,
          categories: vm.search_categories_input,
          team_ids: vm.team_ids,
        })
        .then((response) => {
          vm.search_loading = false;
          vm.search_site_result = response.data;
        })
        .catch((error) => {
          vm.search_loading = false;
          console.error({ error });
        });
    },
  },
  computed: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  .page-header {
    background: #dfdfdf;
    .page-ribbon {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 41px;
      padding: 0px 15px;
      background: #fff;
      .path {
        color: #0884af;
        font-size: 13px;
        display: flex;
        align-items: center;
        img {
          width: 20px;
          margin-right: 6px;
        }
        span {
          margin-top: 4px;
        }
      }
      .ribbon-options {
        display: flex;
        align-items: center;
        .btn-search {
          border: none;
          background: transparent;
          img {
            width: 13px;
            object-fit: contain;
          }
        }
        .btn-customer-user {
          background: transparent;
          border: none;
          display: flex;
          align-items: center;
          .profile-logo {
            width: 15px;
            height: 15px;
            object-fit: cover;
            border-radius: 50%;
            margin-right: 5px;
          }
          span {
            margin-right: 5px;
          }
        }
      }
    }
    .page-options {
      display: flex;
      padding: 6px 15px;
      background: #d0d0d0;
      .btn-option {
        background: transparent;
        color: #000;
        border: none;
        padding: 10px 30px;
        border-radius: 5px;
        cursor: pointer;
        outline: none;
        &.active {
          background: #fff;
          color: #0884af;
        }
      }
    }
  }
  .page-body {
    overflow-y: auto;
    height: calc(100% - 0px);
    padding: 15px 12px;
    .search-section {
      display: flex;
      flex-direction: column;
      background: #fff;
      padding: 10px 15px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      position: relative;
      .search-inputs {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        @media (min-width: 300px) and (max-width: 630px) {
          flex-direction: column;
          align-items: flex-start;
        }
        .search-widget {
          width: 100%;
          background: #ededed;
          border-radius: 5px;
          margin-right: 20px;
          .search-group {
            width: 100%;
            display: flex;
            padding: 0px 8px;
            input {
              border: none;
              background: transparent;
              width: 100%;
              padding-left: 10px;
              border: none;
              outline: none;
              &::placeholder {
                color: rgb(194, 193, 193);
              }
            }
            .search {
              background: transparent;
              border: none;
              width: 22px;
            }
          }
        }
        .search-category-widget {
          margin-right: 15px;
          @media (min-width: 300px) and (max-width: 630px) {
            margin-top: 10px;
          }
        }
        .search-action {
          .search-btn {
            background: #1ba5a4;
            border-radius: 5px;
            height: 45px;
            width: 80px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            @media (min-width: 300px) and (max-width: 630px) {
              position: absolute;
              top: 71px;
              right: 14px;
              width: 57px;
            }
          }
        }
      }
      .search-tags {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .tag {
          background: #ffffff;
          border: 2px solid #e8eaee;
          box-sizing: border-box;
          border-radius: 4px;
          display: flex;
          align-items: center;
          padding: 5px 10px;
          margin-right: 10px;
          @media (min-width: 300px) and (max-width: 630px) {
            margin-bottom: 5px;
          }
          .remove-btn {
            border: none;
            background: transparent;
          }
        }
      }
    }
    .search-result-widget {
      background: #fff;
      padding: 15px 15px;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      margin-top: 10px;
      width: 800px;
      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
      }
      .search-result-header {
        color: #999faa;
        padding-bottom: 6px;
        border-bottom: 1px solid #e9e9e9;
        margin-bottom: 15px;
      }
      .search-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding: 8px;
        cursor: pointer;
        border-radius: 5px;
        &:hover {
          background: rgb(241, 241, 241);
        }
        img {
          width: 40px;
          height: 40px;
          object-fit: cover;
          border-radius: 50%;
        }
        .content {
          display: flex;
          flex-direction: column;
          label {
            padding-left: 10px;
            display: block;
            margin-bottom: 5px;
            font-size: 15px;
          }
          .info-widget {
            display: flex;
            align-items: center;
            .info-item {
              color: #999faa;
              padding: 0px 10px;
              &.divider {
                border-right: 1px solid #999faa;
              }
            }
          }
        }
      }
      .result-counter-widget {
        display: flex;
        justify-content: space-between;
        padding-top: 10px;
        .result-number {
          color: #999faa;
        }
        .show-more-result {
          display: flex;
          align-items: center;
          cursor: pointer;
          button {
            margin-top: 2px;
          }
        }
      }
    }
  }
}
</style>
